class TransformationTimelineScroll {
  constructor(container) {
    this.container = container;
    this.progressLine = null;
    this.progressFill = null;
    this.phases = [];
    this.phaseElements = [];
    this.observer = null;
    this.isInViewport = false;
    this.init();
  }

  init() {
    this.setupElements();
    this.setupObserver();
    this.bindEvents();
  }

  setupElements() {
    this.progressLine = this.container.querySelector('.transformation-timeline__progress-line');
    this.progressFill = this.container.querySelector('.transformation-timeline__progress-fill');
    this.phaseElements = this.container.querySelectorAll('.transformation-timeline__phase');
    this.phases = Array.from(this.phaseElements);
    this.calculateProgressLineHeight();
    
  }

  calculateProgressLineHeight() {
    if (!this.progressLine || this.phases.length === 0) return;
    const timelineContainer = this.container.querySelector('.transformation-timeline__timeline');
    if (!timelineContainer) return;
    const firstPhase = this.phases[0];
    const lastPhase = this.phases[this.phases.length - 1];
    
    if (!firstPhase || !lastPhase) return;
    const firstPhaseOffsetTop = firstPhase.offsetTop;
    const lastPhaseOffsetTop = lastPhase.offsetTop;
    const calculatedHeight = lastPhaseOffsetTop - firstPhaseOffsetTop + 12;
    this.progressLine.style.height = `${calculatedHeight}px`;
    
  }

  setupObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        this.isInViewport = entry.isIntersecting;
        if (this.isInViewport) {
          this.updateProgress();
        }
      });
    }, {
      root: null,
      rootMargin: '-20% 0px -20% 0px',
      threshold: 0
    });

    this.observer.observe(this.container);
  }

  updateProgress() {
    if (!this.progressFill || this.phases.length === 0 || !this.isInViewport) return;
    const timelineContainer = this.container.querySelector('.transformation-timeline__timeline');
    if (!timelineContainer) return;

    const firstPhase = this.phases[0];
    const lastPhase = this.phases[this.phases.length - 1];
    
    if (!firstPhase || !lastPhase) return;

    const viewportHeight = window.innerHeight;
    const viewportCenter = viewportHeight / 2;
    const progressTrigger = viewportCenter;
    const firstPhaseRect = firstPhase.getBoundingClientRect();
    const firstPhaseTop = firstPhaseRect.top;
    const lastPhaseRect = lastPhase.getBoundingClientRect();
    const lastPhaseTop = lastPhaseRect.top;
    let scrollProgress = 0;
    if (firstPhaseTop <= progressTrigger && lastPhaseTop >= progressTrigger) {
      const totalDistance = firstPhaseTop - lastPhaseTop;
      const currentDistance = firstPhaseTop - progressTrigger;
      scrollProgress = Math.max(0, Math.min(1, currentDistance / totalDistance));
    } else if (firstPhaseTop > progressTrigger) {
      scrollProgress = 0;
    } else if (lastPhaseTop < progressTrigger) {
      scrollProgress = 1;
    }
    const progressPercent = scrollProgress * 100;
    this.progressFill.style.height = `${progressPercent}%`;

    if (this.container) {
      this.container.dataset.scrollProgress = scrollProgress.toFixed(3);
      this.container.dataset.progressPercent = progressPercent.toFixed(1) + '%';
    }
    this.updatePhasesStates(scrollProgress);
  }

  updatePhasesStates(scrollProgress) {
    const phasesCount = this.phases.length;
    if (phasesCount === 0) return;
    this.phases.forEach((phase, index) => {
      const activationThreshold = phasesCount > 1 ? index / (phasesCount - 1) : 0;
      const isActive = scrollProgress >= activationThreshold;

      phase.classList.toggle('transformation-timeline__phase--active', isActive);
      const badge = phase.querySelector('.transformation-timeline__phase-badge');
      if (badge) {
        badge.classList.toggle('transformation-timeline__phase-badge--active', isActive);
      }
    });
  }

  bindEvents() {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.updateProgress();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.calculateProgressLineHeight();
        if (this.isInViewport) {
          requestAnimationFrame(() => {
            this.updateProgress();
          });
        }
      }, 150);
    });
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.contains(this.container)) {
        this.destroy();
        setTimeout(() => this.init(), 100);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(this.container)) {
        this.destroy();
      }
    });
    document.addEventListener('shopify:block:select', (event) => {
      if (!this.container.contains(event.target)) return;
      const blockElement = event.target.closest('.transformation-timeline__phase');
      if (blockElement) {
        const phaseIndex = parseInt(blockElement.getAttribute('data-phase-index'));
        if (!isNaN(phaseIndex)) {
        }
      }
    });
  }

  scrollToPhase(index) {
    if (index >= 0 && index < this.phases.length) {
      const phase = this.phases[index];
      const offsetTop = phase.offsetTop + this.container.offsetTop - (window.innerHeight / 2);
      
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.transformation-timeline');
  sections.forEach(section => {
    new TransformationTimelineScroll(section);
  });
});
document.addEventListener('shopify:section:load', function(event) {
  const section = event.target.querySelector('.transformation-timeline');
  if (section) {
    new TransformationTimelineScroll(section);
  }
});